import { useTranslation } from 'react-i18next'
import { Clock3 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ComingSoonBadgeProps {
  /** Short label ("Segera") for tight spots such as the bottom tab bar; screen readers still hear the full label. */
  compact?: boolean
  className?: string
}

/** The one in-place "Segera hadir" state for features that are visible but not released yet. */
export function ComingSoonBadge({ compact = false, className }: ComingSoonBadgeProps) {
  const { t } = useTranslation()

  if (compact) {
    return (
      <span className={cn('prod-soon prod-soon--compact', className)}>
        <span aria-hidden="true">{t('common.comingSoonShort')}</span>
        <span className="sr-only">{t('common.comingSoon')}</span>
      </span>
    )
  }

  return (
    <span className={cn('prod-soon', className)}>
      <Clock3 className="prod-soon__icon" aria-hidden="true" />
      {t('common.comingSoon')}
    </span>
  )
}
